export const formItemPropsKeys = [
  // 'name',
  'children',
  'className',
  'colon',
  'dependencies',
  'extra',
  'fieldKey',
  'getValueFromEvent',
  'getValueProps',
  'hasFeedback',
  'help',
  'hidden',
  'htmlFor',
  'id',
  'initialValue',
  'label',
  'labelAlign',
  'labelCol',
  'labelWrap',
  'layout',
  'marginBottom',
  'messageVariables',
  'normalize',
  'noStyle',
  'onErrorVisibleChanged',
  'prefixCls',
  'preserve',
  'required',
  'requiredMark',
  'rootClassName',
  'rules',
  'shouldUpdate',
  'status',
  'style',
  'tooltip',
  'trigger',
  'validateFirst',
  'validateStatus',
  'validateTrigger',
  'valuePropName',
  'wrapperCol',
];
